export const themes = [
  {
    icon: 'ri-emotion-unhappy-line',
    title: '婚姻的倦怠',
    desc: '它把镜头对准那种“没有大吵大闹，也过不下去”的日常——真正疏远的两个人，往往连争执都懒得开始。',
  },
  {
    icon: 'ri-magic-line',
    title: '旧情与滤镜',
    desc: '重逢放大的常常不是爱情本身，而是我们对青春的那层滤镜。记忆里的那个人，早就被时间改写过了。',
  },
  {
    icon: 'ri-hand-coin-line',
    title: '信任的代价',
    desc: '第二部把情感越界延伸成金钱骗局，说明真正昂贵的从来不是钱，而是“熟人”这两个字带来的安全感。',
  },
  {
    icon: 'ri-home-smile-line',
    title: '密闭空间的张力',
    desc: '度假屋式的封闭场景，让人无处躲藏。空间越小，被压住的话就越多，最后总要从某个缝隙里溢出来。',
  },
  {
    icon: 'ri-group-line',
    title: '群像叙事',
    desc: '没有绝对的主角，几条线共同拼出一幅中年图景。你很难简单地批判谁，因为每个人都有一份自己的难处。',
  },
  {
    icon: 'ri-contrast-drop-line',
    title: '讽刺式收尾',
    desc: '结局不提供安慰，只把问题原样还给观众。它更像一面镜子，而不是一句结论。',
  },
];

export const watchTips = [
  {
    step: '按顺序观看',
    desc: '每一部相对独立，但从第一部看到第三部，人物关系的变化会更完整。',
    icon: 'ri-list-ordered',
  },
  {
    step: '留意“沉默的人”',
    desc: '话最少的那个角色，往往承担着观察与提示的功能，后段很多转折都与他有关。',
    icon: 'ri-user-search-line',
  },
  {
    step: '分清“情感”与“算计”',
    desc: '第二部之后两条线并行，看清哪句是真心、哪句是话术，观感会完全不同。',
    icon: 'ri-split-cells-horizontal',
  },
];